export function journeyParameters(storage?: Pick<Storage, "getItem">, now = Date.now()) {
  try {
    const source = storage ?? (typeof window === "undefined" ? undefined : window.sessionStorage);
    const value = JSON.parse(source?.getItem("spfax_journey_v1") || "null");
    if (value && typeof value.at === "number" && now >= value.at && now - value.at < 1800000
      && ["fax_application", "fax_trial", "ocr_trial", "inquiry"].includes(value.journey_type)
      && ["pricing", "entry_cards", "header", "hero", "floating", "footer", "other"].includes(value.cta_location)) {
      return { journey_type: value.journey_type as string, cta_location: value.cta_location as string };
    }
  } catch { /* 任意計測 */ }
  return { journey_type: "unknown", cta_location: "unknown" };
}
